import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Box from '@mui/material/Box';
import AppBarProps from '../../model/app-bar-props';
import Primary from '../../components/menu-options/primary';
import IconMenu from '../../components/menu-options/icon';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import { StackOverflowIcon } from '../../components/icons';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { SocialMedia } from '../../constants/links';

function ElevationScroll(props: AppBarProps) {
    const { children, window } = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        target: window ? window() : undefined,
    });

    return React.cloneElement(children, {
        elevation: trigger ? 4 : 0,
    });
}


export default function ElevateAppBar(props: AppBarProps) {
    return (
        <>
            <ElevationScroll {...props}>
                <AppBar sx={{ background:"#2D2E32"}}>
                    <Toolbar sx={{justifyContent:"space-between"}}>
                        <Typography variant="h5" component="h1" sx={{color:"rgba(255,255,255,90%)"}}>
                            Abhishek Kumar
                        </Typography>
                        
                        <Box sx={{display:"flex", justifyContent:"space-evenly"}}>
                            <Primary isActive={true} text={"About"} />
                            <Primary text={"Organizations"} />
                            <Primary text={"Works"} />  
                            <Primary text={"Skills"} />
                        </Box>

                        <Box sx={{ display: "flex", justifyContent: "space-evenly" }}>
                            <IconMenu text="Linked In" href={SocialMedia.LINKED_IN}  icon={<LinkedInIcon />}/>
                            <IconMenu text="Github" href={SocialMedia.GITHUB} icon={<GitHubIcon />} />
                            <IconMenu text="Stack Overflow" href={SocialMedia.STACK_OVERFLOW} icon={<StackOverflowIcon />} />
                        </Box>
                        <Box>
                            <Tooltip title="Contact Me">
                                <IconButton aria-label='contact' href={SocialMedia.MAIL_TO} size={'small'} color="primary">
                                    <MailOutlineIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Toolbar>
                </AppBar>
            </ElevationScroll>
            <Toolbar />
            { props.children }
        </>
    );
}


